import 'slick-carousel'
import gsap from "gsap";


(function ($) {
    var slider = $('.success_stories .success_stories-slider');
    var circle = $('.success_stories .circle');
    slider.on('init', function (event, slick) {
        gsap.to($('.slick-active .item0 a'), 0.4,
            {
                opacity: 1,
            }
        );

        gsap.to($('.slick-active .item0 .small-text'), 0.4,
            {
                opacity: 1,
            }
        );


    });
    slider.slick({
        arrows: false,
        dots: false,
        centerMode: true,
        centerPadding: '25%',
        slidesToShow: 1,
        touchMove: false,
        swipe: false,
        autoplay: true,
        autoplaySpeed: 6000,
        responsive: [{
            breakpoint: 480,
            settings: {
                centerPadding: '0%',
                touchMove: true,
                swipe: true,
            }

        }]

    });

    slider.on('afterChange', function (event, slick, currentSlide) {


        gsap.to($('.success_stories-slider .item' + currentSlide + ' a'), 0.4,
            {
                opacity: 1,

            }
        );

        gsap.to($('.success_stories-slider .item' + currentSlide + ' .small-text'), 0.4,
            {
                opacity: 1,

            }
        );


    });


    slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $('.bg-wrap .bg-section').removeClass('active')
        $('.bg-wrap .bg-' + nextSlide + '').addClass('active')

        gsap.to($('.success_stories-slider .item' + currentSlide + ' a'), 0.4,
            {
                opacity: 0.4,

            }
        );

        gsap.to($('.success_stories-slider .item' + currentSlide + ' .small-text'), 0.4,
            {
                opacity: 0,

            }
        );


    });

    slider.find('.title').click(function (e) {
        e.preventDefault();
        var slideno = $(this).data('slide');
        var currentSlide = slider.slick('slickCurrentSlide');
        var maxIndex = slider.find('.slick-slide').not('.slick-cloned').length


        if ($(this).closest('.slick-slide').hasClass('slick-active')) {
            location.href = $(this).find('a').attr('href');

        } else {
            if (slideno == (maxIndex - 1) && currentSlide == 0) {
                slider.slick('slickPrev');
            } else if (slideno == 0 && currentSlide == (maxIndex - 1)) {
                slider.slick('slickNext');
            } else if (slideno == 0) {
                slider.slick('slickPrev');
            } else if (slideno > currentSlide) {
                slider.slick('slickNext');
            } else {
                slider.slick('slickPrev');
            }
        }


    });

    slider.find('.title a').hover(function () {
        if ($(this).closest('.slick-slide').hasClass('slick-active')) {
            gsap.to(circle, 0.5, {background: '#03b7dc', borderColor: '#03b7dc'})
        }
    }, function () {
        gsap.to(circle, 0.5, {background: 'transparent', borderColor: '#e7e7e7'})

    });

    slider.find('.title a').on('touchstart', function () {
        if ($(this).closest('.slick-slide').hasClass('slick-active')) {
            gsap.to(circle, 0.5, {background: '#03b7dc', borderColor: '#03b7dc'})
        }
    });

    slider.find('.title a').on('touchend', function () {
        if ($(this).closest('.slick-slide').hasClass('slick-active')) {
            gsap.to(circle, 0.5, {background: 'transparent', borderColor: '#e7e7e7'})
        }
    });


})(jQuery);